import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  pageSize: storage.session.getItem(types.LOCATIONS_PAGE_SIZE) || 10,
  searchTerm: storage.session.getItem(types.LOCATIONS_SEARCH_TERM) || '',
  sortDir: storage.session.getItem(types.LOCATIONS_SORT_DIR) || 'asc',
  orderBy: storage.session.getItem(types.LOCATIONS_ORDER_BY) || 'firm',
  filterBy: parseInt(storage.local.getItem(types.LOCATIONS_FILTER_BY)) || null,
  filterOptions: [],
  locationTree: null,
  locations: [],
  location: null,
  locationsFound: [],
  preferences: []
})



// WEBPACK FOOTER //
// ./src/store/modules/locations/state.js